<template>
    <IconBase v-bind="$props" v-on="$listeners">
        <path
            d="M12 2.5c.38 0 .73.22.9.56l2.44 4.95 5.46.8a1 1 0 0 1 .56 1.7l-3.95 3.85.93 5.44a1 1 0 0 1-1.45 1.05L12 18.74l-4.88 2.56a1 1 0 0 1-1.45-1.05l.93-5.44-3.95-3.85a1 1 0 0 1 .56-1.7l5.46-.8L11.1 3.06c.17-.34.52-.56.9-.56Z"
            fill="currentColor" />
    </IconBase>
</template>

<script>
import IconBase from './iconBase/IconBase.vue'
import iconProps from './iconBase/iconProps.js'

export default {
    components: { IconBase },
    props: {
        ...iconProps,
        height: {
            ...iconProps.height,
            default: 22,
        },
        width: {
            ...iconProps.width,
            default: 22,
        },
        viewBox: {
            ...iconProps.viewBox,
            default: "0 0 24 24",
        }
    },
}
</script>
